<template>
    <div class="transaction-form-page">
        <div class="container">
            <form class="transaction-form" @submit.prevent="submitForm">
                <div class="form-inner">
                    <div class="page-header">
                        <div class="page-title text-h2 text-bold text-center" :class="type">
                            {{ type === 'create' ? 'Створення' : 'Редагування' }} транзакції
                        </div>

                        <div
                            v-if="type === 'edit' && canDeleteTransaction"
                            class="delete-btn"
                            @click="openConfirmTransactionDeleteModal"
                        >
                            <svg
                                width="20"
                                height="21"
                                viewBox="0 0 20 21"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M8.4 5.43633H11.6C11.6 5.01198 11.4314 4.60502 11.1314 4.30496C10.8313 4.0049 10.4243 3.83633 10 3.83633C9.57565 3.83633 9.16869 4.0049 8.86863 4.30496C8.56857 4.60502 8.4 5.01198 8.4 5.43633ZM6.8 5.43633C6.8 4.58764 7.13714 3.7737 7.73726 3.17359C8.33737 2.57347 9.15131 2.23633 10 2.23633C10.8487 2.23633 11.6626 2.57347 12.2627 3.17359C12.8629 3.7737 13.2 4.58764 13.2 5.43633H17.2C17.4122 5.43633 17.6157 5.52061 17.7657 5.67064C17.9157 5.82067 18 6.02415 18 6.23633C18 6.4485 17.9157 6.65198 17.7657 6.80201C17.6157 6.95204 17.4122 7.03633 17.2 7.03633H16.4944L15.7856 15.3083C15.7175 16.1071 15.352 16.8512 14.7615 17.3934C14.171 17.9356 13.3985 18.2364 12.5968 18.2363H7.4032C6.60153 18.2364 5.82902 17.9356 5.23852 17.3934C4.64802 16.8512 4.28254 16.1071 4.2144 15.3083L3.5056 7.03633H2.8C2.58783 7.03633 2.38434 6.95204 2.23431 6.80201C2.08429 6.65198 2 6.4485 2 6.23633C2 6.02415 2.08429 5.82067 2.23431 5.67064C2.38434 5.52061 2.58783 5.43633 2.8 5.43633H6.8ZM12.4 10.2363C12.4 10.0242 12.3157 9.82067 12.1657 9.67064C12.0157 9.52061 11.8122 9.43633 11.6 9.43633C11.3878 9.43633 11.1843 9.52061 11.0343 9.67064C10.8843 9.82067 10.8 10.0242 10.8 10.2363V13.4363C10.8 13.6485 10.8843 13.852 11.0343 14.002C11.1843 14.152 11.3878 14.2363 11.6 14.2363C11.8122 14.2363 12.0157 14.152 12.1657 14.002C12.3157 13.852 12.4 13.6485 12.4 13.4363V10.2363ZM8.4 9.43633C8.61217 9.43633 8.81566 9.52061 8.96569 9.67064C9.11571 9.82067 9.2 10.0242 9.2 10.2363V13.4363C9.2 13.6485 9.11571 13.852 8.96569 14.002C8.81566 14.152 8.61217 14.2363 8.4 14.2363C8.18783 14.2363 7.98434 14.152 7.83431 14.002C7.68429 13.852 7.6 13.6485 7.6 13.4363V10.2363C7.6 10.0242 7.68429 9.82067 7.83431 9.67064C7.98434 9.52061 8.18783 9.43633 8.4 9.43633ZM5.808 15.1723C5.84208 15.5719 6.02493 15.944 6.32035 16.2151C6.61577 16.4863 7.00223 16.6366 7.4032 16.6363H12.5968C12.9975 16.6362 13.3836 16.4857 13.6786 16.2146C13.9737 15.9435 14.1563 15.5716 14.1904 15.1723L14.888 7.03633H5.112L5.808 15.1723Z"
                                    fill="#D97706"
                                />
                            </svg>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <div class="select-wrap">
                                <div class="select-label text-h5 text-grey">Тип транзакції</div>
                                <Multiselect
                                    ref="transactionTypeSelect"
                                    v-model="transactionForm.type"
                                    class="transaction-type-select"
                                    placeholder="Тип транзакції"
                                    value-prop="slug"
                                    :options="formattedTransactionTypes"
                                    :resolve-on-load="true"
                                    :close-on-select="true"
                                    :disabled="type === 'edit'"
                                    @select="onTransactionTypeChange"
                                    @clear="onTransactionTypeChange"
                                >
                                    <template #caret>
                                        <CollapseToggler :opened="false" />
                                    </template>

                                    <template #singlelabel="{ value }">
                                        <div class="value-text">
                                            <span class="text-h3">{{ value.name }}</span>
                                        </div>
                                    </template>
                                    <template #option="{ option }">
                                        <div class="option-text">
                                            <span class="text-h3">{{ option.name }}</span>
                                        </div>
                                    </template>
                                </Multiselect>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="date-picker-wrap date-single">
                                <div class="date-picker-label text-h5 text-grey">Дата</div>
                                <VueDatePicker
                                    ref="transactionDatepicker"
                                    v-model="transactionForm.date"
                                    class="date-"
                                    :month-change-on-scroll="false"
                                    :config="{ noSwipe: true }"
                                    :enable-time-picker="false"
                                    placeholder="Дата"
                                    model-type="dd.MM.yyyy"
                                    month-name-format="short"
                                    :format="'dd.MM.yy'"
                                    hide-offset-dates
                                    select-text="Зберегти"
                                    cancel-text="Скасувати"
                                    locale="ua"
                                    :transitions="false"
                                >
                                </VueDatePicker>
                            </div>
                        </div>

                        <div
                            v-if="
                                formFields.visible.includes('transaction_category_id') &&
                                transactionForm.type
                            "
                            class="col-12"
                        >
                            <div class="select-wrap">
                                <div class="select-label text-h5 text-grey">Категорія</div>
                                <Multiselect
                                    ref="transactionCategorySelect"
                                    v-model="transactionForm.transaction_category_id"
                                    class="transaction-category-select"
                                    placeholder="Оберіть категорію"
                                    value-prop="id"
                                    :options="searchCategory"
                                    :close-on-select="true"
                                    :searchable="true"
                                    :filter-results="false"
                                    :delay="500"
                                    no-options-text="Немає категорій"
                                >
                                    <template #caret>
                                        <CollapseToggler :opened="false" />
                                    </template>

                                    <template #singlelabel="{ value }">
                                        <div class="value-text">
                                            <span class="text-h3">{{ value.name }}</span>
                                        </div>
                                    </template>
                                    <template #option="{ option }">
                                        <div class="option-text">
                                            <span class="text-h3">{{ option.name }}</span>
                                        </div>
                                    </template>
                                </Multiselect>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="account-select" @click="openAccountSelectModal('main')">
                                <div
                                    class="account-group"
                                    :class="{ 'not-empty': mainAccountFieldIsNotEmpty }"
                                >
                                    <span class="text-h3">
                                        {{ transactionForm.main_financial_account_name }}
                                        {{
                                            transactionForm.main_financial_account_name?.length
                                                ? ', '
                                                : ''
                                        }}
                                        {{ transactionForm.main_financial_account_currency?.code }}
                                    </span>
                                    <div class="account-select-btn">
                                        <svg
                                            width="16"
                                            height="16"
                                            viewBox="0 0 16 16"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                fill-rule="evenodd"
                                                clip-rule="evenodd"
                                                d="M7.30423 1.38678C8.11037 1.1407 9.17762 1 10.3229 1C11.4683 1 12.5355 1.1407 13.3417 1.38678C13.7408 1.50862 14.1168 1.66852 14.4082 1.87885C14.6905 2.08266 15 2.41607 15 2.88172V8.90323C15 9.37825 14.6569 9.70536 14.3906 9.89036C14.1007 10.0918 13.7258 10.2515 13.3233 10.3764C12.6853 10.5743 11.8843 10.7132 11.0116 10.7638V13.0803C11.0116 13.5454 10.7081 13.8831 10.422 14.0937C10.1284 14.3099 9.74876 14.4748 9.34476 14.6006C8.52929 14.8547 7.44956 15 6.2907 15C5.13192 15 4.0522 14.8548 3.23671 14.6009C2.83269 14.4751 2.45298 14.3102 2.15938 14.0939C1.87313 13.8831 1.56977 13.5453 1.56977 13.0803V10.1075C1.56977 9.63864 1.88449 9.30491 2.16807 9.10245C2.21486 9.06904 2.26382 9.03691 2.3147 9.006C2.08097 8.9191 1.86764 8.82047 1.68583 8.70894C1.41087 8.54027 1 8.21202 1 7.69893V4.68817C1 4.17809 1.38528 3.8425 1.68072 3.65795C2.00166 3.45747 2.41792 3.30363 2.86645 3.18514C3.62268 2.98537 4.58981 2.85548 5.64785 2.81781C5.67452 2.38543 5.96844 2.07321 6.2377 1.87885C6.52909 1.66852 6.90507 1.50862 7.30423 1.38678ZM5.64588 4.17382C4.70257 4.21085 3.87663 4.32733 3.26888 4.48787C3.01756 4.55426 2.82201 4.62343 2.67801 4.68817C2.82201 4.75292 3.01756 4.82209 3.26888 4.88848C3.87663 5.04902 4.70257 5.16549 5.64588 5.20252V4.17382ZM5.64588 6.55847C4.58862 6.5207 3.62221 6.39085 2.86645 6.1912C2.72904 6.1549 2.59466 6.11529 2.46512 6.07203V7.56043C2.4741 7.56639 2.48427 7.57289 2.49573 7.57992C2.6412 7.66916 2.89775 7.77727 3.27477 7.88003C3.88327 8.04589 4.70775 8.17162 5.64588 8.21201V6.55847ZM7.111 8.24982V7.31907C7.16015 7.33544 7.20982 7.35127 7.25991 7.36657C8.08208 7.61782 9.16955 7.77419 10.3229 7.77419C11.4764 7.77419 12.5446 7.61781 13.3484 7.36461C13.4114 7.34479 13.4736 7.32409 13.5349 7.30248V8.78965C13.5278 8.79495 13.5198 8.80078 13.5107 8.80711C13.3932 8.88869 13.1796 8.9919 12.8573 9.09187C12.3212 9.25817 11.5866 9.38427 10.7556 9.41992C10.6524 9.29162 10.5302 9.18589 10.4133 9.10245C10.1198 8.89286 9.74089 8.73345 9.33826 8.61189C8.72107 8.42556 7.95175 8.29968 7.111 8.24982ZM13.5803 8.74957C13.5806 8.74958 13.5789 8.75197 13.5742 8.75667C13.5776 8.7519 13.58 8.74955 13.5803 8.74957ZM13.5777 5.74487C13.578 5.74489 13.5764 5.7471 13.5721 5.75147C13.5753 5.74704 13.5774 5.74485 13.5777 5.74487ZM2.4042 7.5124C2.40469 7.51236 2.40827 7.51553 2.41348 7.52205C2.40631 7.5157 2.40371 7.51244 2.4042 7.5124ZM2.41659 4.5324C2.41693 4.53237 2.41949 4.53476 2.42327 4.53965C2.41815 4.53487 2.41626 4.53243 2.41659 4.5324ZM7.111 5.83164V4.31394C7.17462 4.3359 7.23911 4.35679 7.30423 4.37667C8.11037 4.62274 9.17762 4.76344 10.3229 4.76344C11.4683 4.76344 12.5355 4.62274 13.3417 4.37667C13.4068 4.35679 13.4713 4.3359 13.5349 4.31394V5.78338C13.5282 5.78854 13.5205 5.79421 13.5118 5.80038C13.399 5.88036 13.1918 5.98267 12.876 6.08212C12.2524 6.27857 11.3483 6.41935 10.3229 6.41935C9.29754 6.41935 8.36889 6.27856 7.71963 6.08016C7.44072 5.99492 7.24 5.90708 7.111 5.83164ZM13.4024 2.88172C13.2855 2.94633 13.1148 3.01918 12.8824 3.09011C12.2608 3.27984 11.3558 3.4086 10.3229 3.4086C9.29005 3.4086 8.38505 3.27984 7.76349 3.09011C7.53113 3.01918 7.36036 2.94633 7.24349 2.88172C7.36036 2.81711 7.53113 2.74426 7.76349 2.67333C8.38505 2.4836 9.29005 2.35484 10.3229 2.35484C11.3558 2.35484 12.2608 2.4836 12.8824 2.67333C13.1148 2.74426 13.2855 2.81711 13.4024 2.88172ZM6.2907 9.58064C5.24488 9.58064 4.32809 9.70955 3.69785 9.89983C3.46424 9.97036 3.29167 10.0429 3.17278 10.1075C3.29167 10.1722 3.46424 10.2447 3.69785 10.3152C4.32809 10.5055 5.24488 10.6344 6.2907 10.6344C7.33652 10.6344 8.2533 10.5055 8.88355 10.3152C9.11716 10.2447 9.28972 10.1722 9.40861 10.1075C9.28972 10.0429 9.11716 9.97036 8.88355 9.89983C8.2533 9.70955 7.33652 9.58064 6.2907 9.58064ZM9.54651 11.536C9.47804 11.5596 9.40851 11.582 9.33826 11.6032C8.525 11.8487 7.4476 11.9892 6.2907 11.9892C5.1338 11.9892 4.0564 11.8487 3.24313 11.6032C3.17289 11.582 3.10336 11.5596 3.03488 11.536V13.0046C3.04419 13.0127 3.05638 13.0225 3.07212 13.0341C3.18216 13.1152 3.38654 13.2179 3.70428 13.3169C4.33229 13.5124 5.24675 13.6452 6.2907 13.6452C7.33456 13.6452 8.24901 13.5123 8.87705 13.3167C9.1948 13.2177 9.39923 13.1149 9.50932 13.0338C9.52503 13.0223 9.53721 13.0125 9.54651 13.0044V11.536Z"
                                                fill="black"
                                            />
                                        </svg>
                                    </div>
                                </div>
                                <div class="account-label text-h3 text-grey">Основний рахунок</div>
                                <div v-if="main_financial_account_error" class="account-error">
                                    <span class="text-h6">
                                        {{ main_financial_account_error }}
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div
                            v-if="formFields.visible.includes('additional_financial_account_id')"
                            class="col-12"
                        >
                            <div class="account-select" @click="openAccountSelectModal('addition')">
                                <div
                                    class="account-group"
                                    :class="{ 'not-empty': additionalAccountFieldIsNotEmpty }"
                                >
                                    <span class="text-h3">
                                        {{ transactionForm.additional_financial_account_name }}
                                        {{
                                            transactionForm.additional_financial_account_name
                                                ?.length
                                                ? ', '
                                                : ''
                                        }}
                                        {{
                                            transactionForm.additional_financial_account_currency
                                                ?.code
                                        }}
                                    </span>
                                    <div class="account-select-btn">
                                        <svg
                                            width="16"
                                            height="16"
                                            viewBox="0 0 16 16"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                fill-rule="evenodd"
                                                clip-rule="evenodd"
                                                d="M7.30423 1.38678C8.11037 1.1407 9.17762 1 10.3229 1C11.4683 1 12.5355 1.1407 13.3417 1.38678C13.7408 1.50862 14.1168 1.66852 14.4082 1.87885C14.6905 2.08266 15 2.41607 15 2.88172V8.90323C15 9.37825 14.6569 9.70536 14.3906 9.89036C14.1007 10.0918 13.7258 10.2515 13.3233 10.3764C12.6853 10.5743 11.8843 10.7132 11.0116 10.7638V13.0803C11.0116 13.5454 10.7081 13.8831 10.422 14.0937C10.1284 14.3099 9.74876 14.4748 9.34476 14.6006C8.52929 14.8547 7.44956 15 6.2907 15C5.13192 15 4.0522 14.8548 3.23671 14.6009C2.83269 14.4751 2.45298 14.3102 2.15938 14.0939C1.87313 13.8831 1.56977 13.5453 1.56977 13.0803V10.1075C1.56977 9.63864 1.88449 9.30491 2.16807 9.10245C2.21486 9.06904 2.26382 9.03691 2.3147 9.006C2.08097 8.9191 1.86764 8.82047 1.68583 8.70894C1.41087 8.54027 1 8.21202 1 7.69893V4.68817C1 4.17809 1.38528 3.8425 1.68072 3.65795C2.00166 3.45747 2.41792 3.30363 2.86645 3.18514C3.62268 2.98537 4.58981 2.85548 5.64785 2.81781C5.67452 2.38543 5.96844 2.07321 6.2377 1.87885C6.52909 1.66852 6.90507 1.50862 7.30423 1.38678ZM5.64588 4.17382C4.70257 4.21085 3.87663 4.32733 3.26888 4.48787C3.01756 4.55426 2.82201 4.62343 2.67801 4.68817C2.82201 4.75292 3.01756 4.82209 3.26888 4.88848C3.87663 5.04902 4.70257 5.16549 5.64588 5.20252V4.17382ZM5.64588 6.55847C4.58862 6.5207 3.62221 6.39085 2.86645 6.1912C2.72904 6.1549 2.59466 6.11529 2.46512 6.07203V7.56043C2.4741 7.56639 2.48427 7.57289 2.49573 7.57992C2.6412 7.66916 2.89775 7.77727 3.27477 7.88003C3.88327 8.04589 4.70775 8.17162 5.64588 8.21201V6.55847ZM7.111 8.24982V7.31907C7.16015 7.33544 7.20982 7.35127 7.25991 7.36657C8.08208 7.61782 9.16955 7.77419 10.3229 7.77419C11.4764 7.77419 12.5446 7.61781 13.3484 7.36461C13.4114 7.34479 13.4736 7.32409 13.5349 7.30248V8.78965C13.5278 8.79495 13.5198 8.80078 13.5107 8.80711C13.3932 8.88869 13.1796 8.9919 12.8573 9.09187C12.3212 9.25817 11.5866 9.38427 10.7556 9.41992C10.6524 9.29162 10.5302 9.18589 10.4133 9.10245C10.1198 8.89286 9.74089 8.73345 9.33826 8.61189C8.72107 8.42556 7.95175 8.29968 7.111 8.24982ZM13.5803 8.74957C13.5806 8.74958 13.5789 8.75197 13.5742 8.75667C13.5776 8.7519 13.58 8.74955 13.5803 8.74957ZM13.5777 5.74487C13.578 5.74489 13.5764 5.7471 13.5721 5.75147C13.5753 5.74704 13.5774 5.74485 13.5777 5.74487ZM2.4042 7.5124C2.40469 7.51236 2.40827 7.51553 2.41348 7.52205C2.40631 7.5157 2.40371 7.51244 2.4042 7.5124ZM2.41659 4.5324C2.41693 4.53237 2.41949 4.53476 2.42327 4.53965C2.41815 4.53487 2.41626 4.53243 2.41659 4.5324ZM7.111 5.83164V4.31394C7.17462 4.3359 7.23911 4.35679 7.30423 4.37667C8.11037 4.62274 9.17762 4.76344 10.3229 4.76344C11.4683 4.76344 12.5355 4.62274 13.3417 4.37667C13.4068 4.35679 13.4713 4.3359 13.5349 4.31394V5.78338C13.5282 5.78854 13.5205 5.79421 13.5118 5.80038C13.399 5.88036 13.1918 5.98267 12.876 6.08212C12.2524 6.27857 11.3483 6.41935 10.3229 6.41935C9.29754 6.41935 8.36889 6.27856 7.71963 6.08016C7.44072 5.99492 7.24 5.90708 7.111 5.83164ZM13.4024 2.88172C13.2855 2.94633 13.1148 3.01918 12.8824 3.09011C12.2608 3.27984 11.3558 3.4086 10.3229 3.4086C9.29005 3.4086 8.38505 3.27984 7.76349 3.09011C7.53113 3.01918 7.36036 2.94633 7.24349 2.88172C7.36036 2.81711 7.53113 2.74426 7.76349 2.67333C8.38505 2.4836 9.29005 2.35484 10.3229 2.35484C11.3558 2.35484 12.2608 2.4836 12.8824 2.67333C13.1148 2.74426 13.2855 2.81711 13.4024 2.88172ZM6.2907 9.58064C5.24488 9.58064 4.32809 9.70955 3.69785 9.89983C3.46424 9.97036 3.29167 10.0429 3.17278 10.1075C3.29167 10.1722 3.46424 10.2447 3.69785 10.3152C4.32809 10.5055 5.24488 10.6344 6.2907 10.6344C7.33652 10.6344 8.2533 10.5055 8.88355 10.3152C9.11716 10.2447 9.28972 10.1722 9.40861 10.1075C9.28972 10.0429 9.11716 9.97036 8.88355 9.89983C8.2533 9.70955 7.33652 9.58064 6.2907 9.58064ZM9.54651 11.536C9.47804 11.5596 9.40851 11.582 9.33826 11.6032C8.525 11.8487 7.4476 11.9892 6.2907 11.9892C5.1338 11.9892 4.0564 11.8487 3.24313 11.6032C3.17289 11.582 3.10336 11.5596 3.03488 11.536V13.0046C3.04419 13.0127 3.05638 13.0225 3.07212 13.0341C3.18216 13.1152 3.38654 13.2179 3.70428 13.3169C4.33229 13.5124 5.24675 13.6452 6.2907 13.6452C7.33456 13.6452 8.24901 13.5123 8.87705 13.3167C9.1948 13.2177 9.39923 13.1149 9.50932 13.0338C9.52503 13.0223 9.53721 13.0125 9.54651 13.0044V11.536Z"
                                                fill="black"
                                            />
                                        </svg>
                                    </div>
                                </div>
                                <div class="account-label text-h3 text-grey">Суміжний рахунок</div>
                            </div>
                        </div>

                        <template
                            v-if="
                                transactionForm.main_financial_account_id && formFields.titles.first
                            "
                        >
                            <div class="sum-block">
                                <div class="block-row">
                                    <div class="divider"></div>
                                    <div class="block-title">
                                        <span class="text-h5 text-grey">
                                            {{ formFields.titles.first }}
                                        </span>
                                        <span
                                            v-if="formFields.titles.firstWithAccountName"
                                            class="text-h5"
                                        >
                                            {{ transactionForm.main_financial_account_name }}
                                            {{
                                                transactionForm.main_financial_account_name?.length
                                                    ? ', '
                                                    : ''
                                            }}
                                            {{
                                                transactionForm.main_financial_account_currency
                                                    ?.code
                                            }}
                                        </span>
                                    </div>
                                    <div class="divider"></div>
                                </div>
                            </div>
                            <div class="col-12">
                                <InputComponent
                                    v-model="transactionForm.original_amount"
                                    label="Сума"
                                    type="text"
                                    :mask="{
                                        number: true,
                                        precision: 2
                                    }"
                                    :required="true"
                                />
                            </div>
                            <div class="col-6">
                                <div class="select-wrap">
                                    <div class="select-label text-h5 text-grey">Валюта</div>
                                    <Multiselect
                                        ref="originalCurrencySelect"
                                        v-model="transactionForm.original_currency"
                                        class="original-currency-select"
                                        placeholder="Валюта"
                                        value-prop="code"
                                        track-by="name"
                                        :options="currencies"
                                        :resolve-on-load="true"
                                        :close-on-select="true"
                                        :searchable="true"
                                        :disabled="
                                            formFields.disabled.includes('original_currency')
                                        "
                                    >
                                        <template #caret>
                                            <CollapseToggler :opened="false" />
                                        </template>

                                        <template #singlelabel="{ value }">
                                            <div class="value-text">
                                                <span class="text-h3">
                                                    {{ value.code }}, {{ value.symbol }}
                                                </span>
                                            </div>
                                        </template>
                                        <template #option="{ option }">
                                            <div class="option-text">
                                                <span class="text-h3">
                                                    {{ option.code }}, {{ option.symbol }}
                                                </span>
                                            </div>
                                        </template>
                                    </Multiselect>
                                </div>
                            </div>
                            <div
                                v-if="!formFields.hidden.includes('original_exchange_rate')"
                                class="col-6"
                            >
                                <InputComponent
                                    v-model="transactionForm.original_exchange_rate"
                                    label="Курс"
                                    type="text"
                                    :mask="{
                                        number: true,
                                        precision: 8
                                    }"
                                    :required="true"
                                    :disabled="
                                        formFields.disabled.includes('original_exchange_rate')
                                    "
                                />
                            </div>

                            <div
                                v-if="formFields.visible.includes('direct_exchange_rate')"
                                class="col-6"
                            >
                                <InputComponent
                                    v-model="transactionForm.direct_exchange_rate"
                                    label="Крос-курс"
                                    type="text"
                                    :mask="{
                                        number: true,
                                        precision: 8
                                    }"
                                    :required="true"
                                    :disabled="formFields.disabled.includes('direct_exchange_rate')"
                                />
                            </div>

                            <template
                                v-if="formFields.visible.includes('workspace_currency_amount')"
                            >
                                <div class="sum-block">
                                    <div class="block-row">
                                        <div class="divider"></div>
                                        <div class="block-title">
                                            <span class="text-h5 text-grey">
                                                {{ workspaceCurrency.code }}
                                                {{ transactionForm.workspace_currency_amount }}
                                            </span>
                                        </div>
                                        <div class="divider"></div>
                                    </div>
                                </div>
                            </template>

                            <div
                                v-if="transactionCase === 5 || transactionCase === 9"
                                class="cross-curs-switch"
                                @click="toggleCrossCurs"
                            >
                                <img
                                    v-if="transactionForm.is_direct_exchange"
                                    src="@/assets/images/full-selected-icon.svg"
                                    alt=""
                                />
                                <img v-else src="@/assets/images/none-selected-icon.svg" alt="" />
                                <span class="text-h4">Крос-курс</span>
                            </div>

                            <div v-if="formFields.titles.second" class="sum-block">
                                <div class="block-row">
                                    <div class="divider"></div>
                                    <div class="block-title">
                                        <span class="text-h5 text-grey">
                                            {{ formFields.titles.second }}
                                        </span>
                                        <span
                                            v-if="formFields.titles.secondWithAccountName"
                                            class="text-h5"
                                        >
                                            {{ transactionForm.additional_financial_account_name }}
                                            {{
                                                transactionForm.additional_financial_account_name
                                                    ?.length
                                                    ? ', '
                                                    : ''
                                            }}
                                            {{
                                                transactionForm
                                                    .additional_financial_account_currency?.code
                                            }}
                                        </span>
                                    </div>
                                    <div class="divider"></div>
                                </div>
                            </div>
                            <div
                                v-if="!formFields.hidden.includes('account_currency')"
                                class="col-6"
                            >
                                <div class="select-wrap">
                                    <div class="select-label text-h5 text-grey">Валюта</div>
                                    <Multiselect
                                        ref="accountCurrencySelect"
                                        v-model="transactionForm.account_currency"
                                        class="account-currency-select"
                                        placeholder="Валюта"
                                        value-prop="code"
                                        track-by="name"
                                        :options="currencies"
                                        :resolve-on-load="true"
                                        :close-on-select="true"
                                        :searchable="true"
                                        :disabled="formFields.disabled.includes('account_currency')"
                                    >
                                        <template #caret>
                                            <CollapseToggler :opened="false" />
                                        </template>

                                        <template #singlelabel="{ value }">
                                            <div class="value-text">
                                                <span class="text-h3">
                                                    {{ value.code }}, {{ value.symbol }}
                                                </span>
                                            </div>
                                        </template>
                                        <template #option="{ option }">
                                            <div class="option-text">
                                                <span class="text-h3">
                                                    {{ option.code }}, {{ option.symbol }}
                                                </span>
                                            </div>
                                        </template>
                                    </Multiselect>
                                </div>
                            </div>
                            <div
                                v-if="!formFields.hidden.includes('account_exchange_rate')"
                                class="col-6"
                            >
                                <InputComponent
                                    v-model="transactionForm.account_exchange_rate"
                                    label="Курс"
                                    type="text"
                                    :mask="{
                                        number: true,
                                        precision: 8
                                    }"
                                    :required="true"
                                    :disabled="
                                        formFields.disabled.includes('account_exchange_rate')
                                    "
                                />
                            </div>
                            <div
                                v-if="!formFields.hidden.includes('account_amount')"
                                class="col-12"
                            >
                                <InputComponent
                                    v-model="transactionForm.account_amount"
                                    label="Сума"
                                    type="text"
                                    :mask="{
                                        number: true,
                                        precision: 2
                                    }"
                                    :required="true"
                                    :disabled="formFields.disabled.includes('account_amount')"
                                />
                            </div>
                        </template>

                        <div class="col-12">
                            <ImagesComponent
                                title-class="text-h3 text-bold"
                                form-data-key="documents[]"
                                :without-preview="true"
                                :block-data="transactionForm.documents"
                                block-title="Файли"
                                @load-image="loadImage"
                            />
                        </div>

                        <div class="col-12">
                            <div class="select-wrap">
                                <div class="select-label text-h5 text-grey">Теги</div>
                                <TagsComponent v-model="transactionForm.labels" />
                            </div>
                        </div>

                        <div class="col-12">
                            <InputComponent
                                v-model="transactionForm.comment"
                                label="Коментар"
                                type="text"
                                :required="true"
                            />
                        </div>
                    </div>
                </div>

                <div class="page-buttons shadow-sm">
                    <div class="container">
                        <ButtonComponent
                            class="cancel-btn"
                            btn-style="grey"
                            text="Скасувати"
                            @click.prevent="closeForm"
                        />

                        <ButtonComponent
                            class="submit-btn"
                            btn-style="gradient"
                            text="Зберегти"
                            :disabled="showLoader"
                            @click.prevent="submitForm"
                        />
                    </div>
                </div>
            </form>

            <AccountSelectModal
                v-model:show="showAccountSelectModal"
                @select-account="selectAccount"
                @cancel-action="cancelAccountSelect"
            />

            <ConfirmationModal
                :show="confirmTransactionDeleteModal.show"
                modal-title="Видалити транзакцію?"
                @submit-action="deleteTransaction"
                @cancel-action="cancelTransactionDelete"
            />

            <ImageDeleteModal modal-title="Видалити файл?" @submit-delete="submitImageDelete" />
        </div>
        <Transition name="fade">
            <LoaderComponent v-if="showLoader" />
        </Transition>
    </div>
</template>

<script>
import InputComponent from '@/components/form/InputComponent.vue'
import Multiselect from '@vueform/multiselect'
import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import CollapseToggler from '@/components/CollapseToggler.vue'
import ConfirmationModal from '@/components/modals/ConfirmationModal.vue'
import AccountSelectModal from '@/components/modals/AccountSelectModal.vue'
import fetchWrapper from '@/helpers/fetch-wrapper.js'
import ImagesComponent from '@/components/ImagesComponent.vue'
import TagsComponent from '@/components/form/TagsComponent.vue'
import ImageDeleteModal from '@/components/modals/ImageDeleteModal.vue'
import LoaderComponent from '@/components/LoaderComponent.vue'
import ButtonComponent from '@/components/ButtonComponent.vue'
import { useActiveRouteStore } from '@/stores/index.js'

export default {
    name: 'TransactionFormView',
    components: {
        TagsComponent,
        ButtonComponent,
        LoaderComponent,
        ImageDeleteModal,
        ImagesComponent,
        Multiselect,
        InputComponent,
        CollapseToggler,
        ConfirmationModal,
        VueDatePicker,
        AccountSelectModal
    },
    setup() {
        const activeRouteStore = useActiveRouteStore()

        return { activeRouteStore }
    },
    data() {
        return {
            transactionForm: {
                type: null,
                date: null,
                transaction_category_id: null,
                main_financial_account_id: null,
                main_financial_account_name: null,
                main_financial_account_currency: null,
                additional_financial_account_id: null,
                additional_financial_account_name: null,
                additional_financial_account_currency: null,
                direct_exchange_rate: null,
                original_amount: null,
                original_currency: null,
                original_exchange_rate: null,
                workspace_currency_amount: null,
                account_amount: null,
                account_currency: null,
                account_exchange_rate: null,
                labels: [],
                documents: [],
                comment: null,
                delete_documents: [],
                is_direct_exchange: false
            },
            accountTypeToSelect: null,
            showAccountSelectModal: false,
            type: 'create',
            transactionTypes: [],
            workspaceCurrency: [],
            currencies: [],
            transaction: null,
            transactionId: null,
            formFields: {
                visible: [],
                hidden: [],
                disabled: [],
                to_clear: [],
                titles: {
                    first: null,
                    second: null,
                    firstWithAccountName: false,
                    secondWithAccountName: false
                }
            },
            imagesPreview: [],
            exchangeRates: [],
            defaultCalculationStrategy: true,
            suppressAmountWatch: false,
            suppressCurrencyWatch: false,
            transactionCase: null,
            confirmTransactionDeleteModal: {
                show: false,
                transaction_id: null
            },
            main_financial_account_error: null,
            showLoader: true
        }
    },
    computed: {
        formattedCurrentDate() {
            const date = new Date()
            const formattedDate = date.toLocaleDateString('uk-UA', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            })

            return formattedDate
        },

        formattedTransactionTypes() {
            return Object.entries(this.transactionTypes).map(([slug, name]) => ({
                slug,
                name
            }))
        },

        mainAccountFieldIsNotEmpty() {
            return (
                this.transactionForm.main_financial_account_name !== '' &&
                this.transactionForm.main_financial_account_name !== null &&
                this.transactionForm.main_financial_account_name !== undefined
            )
        },

        additionalAccountFieldIsNotEmpty() {
            return (
                this.transactionForm.additional_financial_account_name !== '' &&
                this.transactionForm.additional_financial_account_name !== null &&
                this.transactionForm.additional_financial_account_name !== undefined
            )
        },

        canDeleteTransaction() {
            return this.transaction?.permissions?.delete
        },

        formattedOriginalAmount() {
            return parseFloat(this.transactionForm.original_amount?.toString().replace(',', '.'))
        },

        formattedOriginalExchangeRate() {
            return parseFloat(
                this.transactionForm.original_exchange_rate?.toString().replace(',', '.')
            )
        },

        formattedDirectExchangeRate() {
            return parseFloat(
                this.transactionForm.direct_exchange_rate?.toString().replace(',', '.')
            )
        },

        formattedWorkspaceAmount() {
            return parseFloat(
                this.transactionForm.workspace_currency_amount?.toString().replace(',', '.')
            )
        },

        formattedAccountAmount() {
            return parseFloat(this.transactionForm.account_amount?.toString().replace(',', '.'))
        },

        formattedAccountExchangeRate() {
            return parseFloat(
                this.transactionForm.account_exchange_rate?.toString().replace(',', '.')
            )
        }
    },
    watch: {
        'transactionForm.type': function () {
            this.updateFormFields(false)
        },
        'transactionForm.original_currency': function () {
            this.updateFormFields()
        },
        'transactionForm.account_currency': function () {
            this.updateFormFields()
        },
        'transactionForm.is_direct_exchange': function () {
            this.updateFormFields()
        },
        'transactionForm.original_amount': function () {
            this.handleInputWatch('original_amount')
        },
        'transactionForm.account_amount': function () {
            this.handleInputWatch('account_amount')
        },
        'transactionForm.original_exchange_rate': function () {
            this.handleInputWatch('original_exchange_rate')
        },
        'transactionForm.account_exchange_rate': function () {
            this.handleInputWatch('account_exchange_rate')
        },
        'transactionForm.direct_exchange_rate': function () {
            this.handleInputWatch('direct_exchange_rate')
        }
    },
    created() {
        this.transactionForm.date = this.formattedCurrentDate

        if (this.$route.params.id) {
            this.type = 'edit'
            this.transactionId = this.$route.params.id
        }
    },
    mounted() {
        this.loadInfo()
    },
    methods: {
        toggleCrossCurs() {
            this.transactionForm.is_direct_exchange = !this.transactionForm.is_direct_exchange
        },

        async loadInfo() {
            let url

            if (this.type === 'create') {
                url = 'form-create'
            }

            if (this.type === 'edit') {
                url = `form-edit/${this.transactionId}`
            }

            await fetchWrapper
                .post(`${import.meta.env.VITE_FINANCE_URL}/transactions/${url}`)
                .then((response) => {
                    console.log(response)
                    this.type = response.data.type
                    this.transactionTypes = response.data.transactionTypes
                    this.workspaceCurrency = response.data.workspaceCurrency
                    this.currencies = response.data.currencies

                    if (this.type === 'edit') {
                        this.transaction = response.data.transaction
                        this.setValues()
                    }
                })
                .finally(() => {
                    this.showLoader = false
                })
        },

        async updateFormFields(loadExchangeRate = true, withClear = true) {
            if (this.suppressCurrencyWatch || this.suppressAmountWatch) {
                return
            }

            this.suppressCurrencyWatch = true
            this.suppressAmountWatch = true

            const {
                type,
                original_currency,
                main_financial_account_currency,
                additional_financial_account_currency
            } = this.transactionForm

            if (type === 'income' || type === 'expense') {
                if (main_financial_account_currency?.code === this.workspaceCurrency.code) {
                    if (original_currency === this.workspaceCurrency.code) {
                        console.log('---Case 1---')
                        this.transactionCase = 1

                        this.formFields = {
                            visible: ['transaction_category_id'],
                            hidden: [
                                'original_exchange_rate',
                                'account_amount',
                                'account_currency',
                                'account_exchange_rate'
                            ],
                            disabled: [
                                'original_exchange_rate',
                                'account_amount',
                                'account_currency',
                                'account_exchange_rate'
                            ],
                            to_clear: [
                                'additional_financial_account_id',
                                'additional_financial_account_name',
                                'additional_financial_account_currency',
                                'workspace_currency_amount',
                                'account_amount',
                                'account_currency',
                                'account_exchange_rate',
                                'direct_exchange_rate'
                            ],
                            titles: {
                                first: type === 'income' ? 'На рахунок' : 'З рахунку',
                                second: null,
                                firstWithAccountName: true,
                                secondWithAccountName: false
                            }
                        }

                        if (withClear) {
                            this.clearSomeFields()
                        }

                        this.exchangeRates = [
                            {
                                sameCurrency: true,
                                resultField: 'original_exchange_rate'
                            },
                            {
                                sameCurrency: true,
                                resultField: 'account_exchange_rate'
                            }
                        ]

                        this.defaultCalculationStrategy = true
                    } else {
                        console.log('---Case 2---')
                        this.transactionCase = 2

                        this.formFields = {
                            visible: ['transaction_category_id', 'workspace_currency_amount'],
                            hidden: ['account_amount', 'account_currency', 'account_exchange_rate'],
                            disabled: [
                                'account_amount',
                                'account_currency',
                                'account_exchange_rate'
                            ],
                            to_clear: [
                                'additional_financial_account_id',
                                'additional_financial_account_name',
                                'additional_financial_account_currency',
                                'account_amount',
                                'account_currency',
                                'account_exchange_rate',
                                'direct_exchange_rate'
                            ],
                            titles: {
                                first: type === 'income' ? 'На рахунок' : 'З рахунку',
                                second: null,
                                firstWithAccountName: true,
                                secondWithAccountName: false
                            }
                        }

                        if (withClear) {
                            this.clearSomeFields()
                        }

                        this.exchangeRates = [
                            {
                                firstCurrency: this.transactionForm.original_currency,
                                secondCurrency: this.workspaceCurrency.code,
                                resultField: 'original_exchange_rate'
                            }
                        ]

                        this.defaultCalculationStrategy = true
                    }
                } else {
                    if (original_currency === this.workspaceCurrency.code) {
                        console.log('---Case 3---')
                        this.transactionCase = 3

                        this.formFields = {
                            visible: ['transaction_category_id'],
                            hidden: ['original_exchange_rate'],
                            disabled: ['original_exchange_rate', 'account_currency'],
                            to_clear: [
                                'additional_financial_account_id',
                                'additional_financial_account_name',
                                'additional_financial_account_currency',
                                'workspace_currency_amount',
                                'direct_exchange_rate'
                            ],
                            titles: {
                                first: 'Сума в обраній валюті',
                                second: 'Сума у валюті рахунку',
                                firstWithAccountName: false,
                                secondWithAccountName: false
                            }
                        }

                        if (withClear) {
                            this.clearSomeFields()
                        }

                        if (this.transactionForm.main_financial_account_id) {
                            this.$nextTick().then(() => {
                                this.$refs.accountCurrencySelect.select(
                                    this.transactionForm.main_financial_account_currency
                                )
                            })
                        }

                        this.exchangeRates = [
                            {
                                sameCurrency: true,
                                resultField: 'original_exchange_rate'
                            },
                            {
                                firstCurrency: this.workspaceCurrency.code,
                                secondCurrency: this.transactionForm.original_currency,
                                resultField: 'account_exchange_rate'
                            }
                        ]

                        this.defaultCalculationStrategy = true
                    } else {
                        if (original_currency === main_financial_account_currency?.code) {
                            console.log('---Case 4---')
                            this.transactionCase = 4

                            this.formFields = {
                                visible: ['transaction_category_id', 'workspace_currency_amount'],
                                hidden: [
                                    'account_amount',
                                    'account_currency',
                                    'account_exchange_rate'
                                ],
                                disabled: [
                                    'account_amount',
                                    'account_currency',
                                    'account_exchange_rate'
                                ],
                                to_clear: [
                                    'additional_financial_account_id',
                                    'additional_financial_account_name',
                                    'additional_financial_account_currency',
                                    'account_amount',
                                    'account_currency',
                                    'account_exchange_rate',
                                    'direct_exchange_rate'
                                ],
                                titles: {
                                    first: type === 'income' ? 'Сума на рахунок' : 'Сума з рахунку',
                                    second: null,
                                    firstWithAccountName: true,
                                    secondWithAccountName: false
                                }
                            }

                            if (withClear) {
                                this.clearSomeFields()
                            }

                            this.exchangeRates = [
                                {
                                    firstCurrency: this.transactionForm.original_currency,
                                    secondCurrency: this.workspaceCurrency.code,
                                    resultField: 'original_exchange_rate'
                                }
                            ]

                            this.defaultCalculationStrategy = false
                        } else {
                            console.log('---Case 5---')
                            this.transactionCase = 5

                            this.formFields = {
                                visible: ['transaction_category_id', 'workspace_currency_amount'],
                                hidden: [],
                                disabled: ['account_currency'],
                                to_clear: [
                                    'additional_financial_account_id',
                                    'additional_financial_account_name',
                                    'additional_financial_account_currency',
                                    'direct_exchange_rate'
                                ],
                                titles: {
                                    first: 'Сума в обраній валюті',
                                    second: 'Сума у валюті рахунку',
                                    firstWithAccountName: false,
                                    secondWithAccountName: false
                                }
                            }

                            if (withClear) {
                                this.clearSomeFields()
                            }

                            if (this.transactionForm.main_financial_account_id) {
                                this.$nextTick().then(() => {
                                    this.$refs.accountCurrencySelect.select(
                                        this.transactionForm.main_financial_account_currency
                                    )
                                })
                            }

                            this.exchangeRates = [
                                {
                                    firstCurrency: this.transactionForm.original_currency,
                                    secondCurrency: this.workspaceCurrency.code,
                                    resultField: 'original_exchange_rate'
                                },
                                {
                                    firstCurrency: this.workspaceCurrency.code,
                                    secondCurrency:
                                        this.transactionForm.main_financial_account_currency?.code,
                                    resultField: 'account_exchange_rate'
                                }
                            ]

                            if (this.transactionForm.is_direct_exchange) {
                                this.formFields.visible.push('direct_exchange_rate')
                                this.formFields.hidden.push(
                                    'original_exchange_rate',
                                    'account_exchange_rate'
                                )
                                this.formFields.disabled.push(
                                    'original_exchange_rate',
                                    'account_exchange_rate'
                                )
                                this.exchangeRates.push({
                                    firstCurrency: this.transactionForm.original_currency,
                                    secondCurrency:
                                        this.transactionForm.main_financial_account_currency?.code,
                                    resultField: 'direct_exchange_rate'
                                })
                            }

                            this.defaultCalculationStrategy = true
                        }
                    }
                }
            } else if (type === 'transfer_account') {
                this.formFields.to_clear = [
                    'transaction_category_id',
                    'original_amount',
                    'original_currency',
                    'original_exchange_rate',
                    'workspace_currency_amount',
                    'account_amount',
                    'account_currency',
                    'account_exchange_rate',
                    'direct_exchange_rate'
                ]

                if (withClear) {
                    this.clearSomeFields()
                }

                if (this.transactionForm.main_financial_account_id) {
                    this.$refs.originalCurrencySelect?.select(
                        this.transactionForm.main_financial_account_currency
                    )
                }

                if (this.transactionForm.additional_financial_account_id) {
                    this.$refs.accountCurrencySelect?.select(
                        this.transactionForm.additional_financial_account_currency
                    )
                }

                if (
                    main_financial_account_currency?.code ===
                    additional_financial_account_currency?.code
                ) {
                    if (
                        main_financial_account_currency?.code ===
                            additional_financial_account_currency?.code &&
                        main_financial_account_currency?.code === this.workspaceCurrency.code
                    ) {
                        console.log('---Case 6---')
                        this.transactionCase = 6

                        this.formFields = {
                            visible: ['additional_financial_account_id'],
                            hidden: ['account_amount', 'account_currency', 'account_exchange_rate'],
                            disabled: [
                                'original_currency',
                                'original_exchange_rate',
                                'account_amount',
                                'account_currency',
                                'account_exchange_rate'
                            ],
                            titles: {
                                first: 'Сума переказу',
                                second: null,
                                firstWithAccountName: false,
                                secondWithAccountName: false
                            }
                        }

                        this.exchangeRates = [
                            {
                                sameCurrency: true,
                                resultField: 'original_exchange_rate'
                            },
                            {
                                sameCurrency: true,
                                resultField: 'account_exchange_rate'
                            }
                        ]

                        this.defaultCalculationStrategy = true
                    } else {
                        console.log('---Case 7---')
                        this.transactionCase = 7

                        this.formFields = {
                            visible: [
                                'additional_financial_account_id',
                                'workspace_currency_amount'
                            ],
                            hidden: ['account_amount', 'account_currency', 'account_exchange_rate'],
                            disabled: [
                                'original_currency',
                                'account_amount',
                                'account_currency',
                                'account_exchange_rate'
                            ],
                            titles: {
                                first: 'Сума переказу',
                                second: null,
                                firstWithAccountName: true,
                                secondWithAccountName: true
                            }
                        }

                        this.exchangeRates = [
                            {
                                firstCurrency:
                                    this.transactionForm.main_financial_account_currency?.code,
                                secondCurrency: this.workspaceCurrency.code,
                                resultField: 'original_exchange_rate'
                            }
                        ]

                        this.defaultCalculationStrategy = false
                    }
                } else {
                    if (
                        main_financial_account_currency?.code === this.workspaceCurrency.code ||
                        additional_financial_account_currency?.code === this.workspaceCurrency.code
                    ) {
                        if (
                            additional_financial_account_currency?.code ===
                            this.workspaceCurrency.code
                        ) {
                            console.log('---Case 8.1---')
                            this.transactionCase = 8.1

                            this.formFields = {
                                visible: ['additional_financial_account_id'],
                                hidden: ['account_exchange_rate'],
                                disabled: [
                                    'original_currency',
                                    'account_currency',
                                    'account_exchange_rate'
                                ],
                                titles: {
                                    first: 'Сума з рахунку',
                                    second: 'Сума на рахунок',
                                    firstWithAccountName: true,
                                    secondWithAccountName: true
                                }
                            }

                            this.exchangeRates = [
                                {
                                    firstCurrency:
                                        this.transactionForm.main_financial_account_currency?.code,
                                    secondCurrency: this.workspaceCurrency?.code,
                                    resultField: 'original_exchange_rate'
                                },
                                {
                                    sameCurrency: true,
                                    resultField: 'account_exchange_rate'
                                }
                            ]

                            this.defaultCalculationStrategy = true
                        } else {
                            console.log('---Case 8.2---')
                            this.transactionCase = 8.2

                            this.formFields = {
                                visible: ['additional_financial_account_id'],
                                hidden: ['original_exchange_rate'],
                                disabled: [
                                    'original_currency',
                                    'original_exchange_rate',
                                    'account_currency'
                                ],
                                titles: {
                                    first: 'Сума з рахунку',
                                    second: 'Сума на рахунок',
                                    firstWithAccountName: true,
                                    secondWithAccountName: true
                                }
                            }

                            this.exchangeRates = [
                                {
                                    sameCurrency: true,
                                    resultField: 'original_exchange_rate'
                                },
                                {
                                    firstCurrency: this.workspaceCurrency?.code,
                                    secondCurrency:
                                        this.transactionForm.additional_financial_account_currency
                                            ?.code,
                                    resultField: 'account_exchange_rate'
                                }
                            ]

                            this.defaultCalculationStrategy = true
                        }
                    } else {
                        console.log('---Case 9---')
                        this.transactionCase = 9

                        this.formFields = {
                            visible: [
                                'additional_financial_account_id',
                                'workspace_currency_amount'
                            ],
                            hidden: [],
                            disabled: ['original_currency', 'account_currency'],
                            titles: {
                                first: 'Сума з рахунку',
                                second: 'Сума на рахунок',
                                firstWithAccountName: true,
                                secondWithAccountName: true
                            }
                        }

                        this.exchangeRates = [
                            {
                                firstCurrency:
                                    this.transactionForm.main_financial_account_currency?.code,
                                secondCurrency: this.workspaceCurrency.code,
                                resultField: 'original_exchange_rate'
                            },
                            {
                                firstCurrency: this.workspaceCurrency.code,
                                secondCurrency:
                                    this.transactionForm.additional_financial_account_currency
                                        ?.code,
                                resultField: 'account_exchange_rate'
                            }
                        ]

                        if (this.transactionForm.is_direct_exchange) {
                            this.formFields.visible.push('direct_exchange_rate')
                            this.formFields.hidden.push(
                                'original_exchange_rate',
                                'account_exchange_rate'
                            )
                            this.formFields.disabled.push(
                                'original_exchange_rate',
                                'account_exchange_rate'
                            )
                            this.exchangeRates.push({
                                firstCurrency:
                                    this.transactionForm.main_financial_account_currency?.code,
                                secondCurrency:
                                    this.transactionForm.additional_financial_account_currency
                                        ?.code,
                                resultField: 'direct_exchange_rate'
                            })
                        }

                        this.defaultCalculationStrategy = true
                    }
                }
            }

            this.suppressCurrencyWatch = false
            this.suppressAmountWatch = false

            if (loadExchangeRate) {
                await this.getExchangeRate()
            }
        },

        clearSomeFields() {
            this.formFields.to_clear.map((item) => {
                this.transactionForm[item] = null
            })
        },

        async getExchangeRate() {
            this.exchangeRates.map((item) => {
                if (item.sameCurrency) {
                    this.transactionForm[item.resultField] = 1

                    return
                }

                if (
                    !item.firstCurrency ||
                    !item.secondCurrency ||
                    item.firstCurrency === item.secondCurrency
                ) {
                    return
                }

                fetchWrapper
                    .post(`${import.meta.env.VITE_FINANCE_URL}/currency/get-exchange-rate`, {
                        first_currency_code: item.firstCurrency,
                        second_currency_code: item.secondCurrency
                    })
                    .then((response) => {
                        this.transactionForm[item.resultField] = response.data.exchange_rate
                    })
                    .catch((error) => {
                        const errorMessage =
                            error.response?.data?.message || error.message || 'An error occurred'

                        this.$toast.error(errorMessage)
                    })
            })
        },

        handleInputWatch(field) {
            if (!this.suppressAmountWatch) {
                this.suppressAmountWatch = true
                this.calculateAmount(field)

                this.$nextTick(() => {
                    this.suppressAmountWatch = false
                })
            }
        },

        toCents(amount) {
            return Math.round(Number(amount) * 100)
        },

        fromCents(cents) {
            return cents / 100
        },

        computeWorkspaceAmount(amount, exchangeRate) {
            const amountCents = this.toCents(amount)
            const workspaceCents = Math.round(amountCents * Number(exchangeRate))

            return isNaN(workspaceCents) ? 0 : this.fromCents(workspaceCents)
        },

        roundToTwo(num) {
            return parseFloat(Number(num).toFixed(2))
        },

        roundToEight(num) {
            return parseFloat(Number(num).toFixed(8))
        },

        calculateAmount(inputTrigger) {
            if (
                this.transactionForm.is_direct_exchange === true &&
                [5, 9].includes(this.transactionCase)
            ) {
                this.calculateDirectExchange(inputTrigger)

                return
            }

            const requiredFields = [
                'original_amount',
                'original_exchange_rate',
                'account_amount',
                'account_exchange_rate'
            ]

            const nullFieldsCount = requiredFields.filter(
                (field) => this.transactionForm[field] === null
            ).length

            const nullFieldsAllowed = this.exchangeRates.length === 2 ? 2 : 3

            if (nullFieldsCount >= nullFieldsAllowed) {
                console.log('Not enough data to perform calculation')

                return
            }

            const forwardCalculation = [
                'original_amount',
                'original_exchange_rate',
                'account_exchange_rate'
            ].includes(inputTrigger)

            if (this.defaultCalculationStrategy) {
                if (forwardCalculation) {
                    this.transactionForm.workspace_currency_amount = this.computeWorkspaceAmount(
                        this.formattedOriginalAmount,
                        this.formattedOriginalExchangeRate
                    )

                    const accountAmount =
                        Number(this.formattedWorkspaceAmount) *
                        Number(this.formattedAccountExchangeRate)

                    this.transactionForm.account_amount = this.roundToTwo(accountAmount) || null
                } else {
                    let originalAmount

                    if ([8.1, 5].includes(this.transactionCase)) {
                        originalAmount =
                            Number(this.formattedAccountAmount) /
                            Number(this.formattedAccountExchangeRate) /
                            Number(this.formattedOriginalExchangeRate)
                    } else {
                        originalAmount =
                            Number(this.formattedAccountAmount) /
                            Number(this.formattedAccountExchangeRate)
                    }
                    originalAmount = this.roundToTwo(originalAmount)
                    this.transactionForm.original_amount = originalAmount || null

                    if ([8.1, 5].includes(this.transactionCase)) {
                        this.transactionForm.workspace_currency_amount =
                            this.computeWorkspaceAmount(
                                this.formattedOriginalAmount,
                                this.formattedOriginalExchangeRate
                            )
                    } else {
                        const accountAmountCents = this.toCents(this.formattedAccountAmount)
                        const workspaceCents = Math.round(
                            accountAmountCents * Number(this.formattedAccountExchangeRate)
                        )

                        this.transactionForm.workspace_currency_amount = isNaN(workspaceCents)
                            ? 0
                            : this.fromCents(workspaceCents)
                    }
                }
            } else {
                if (forwardCalculation) {
                    this.transactionForm.workspace_currency_amount = this.computeWorkspaceAmount(
                        this.formattedOriginalAmount,
                        this.formattedOriginalExchangeRate
                    )
                    this.transactionForm.account_amount = this.formattedOriginalAmount
                } else if (this.transactionCase !== 4) {
                    const accountAmountCents = this.toCents(this.formattedAccountAmount)
                    const workspaceCents = Math.round(
                        accountAmountCents * Number(this.formattedAccountExchangeRate)
                    )

                    this.transactionForm.workspace_currency_amount = isNaN(workspaceCents)
                        ? 0
                        : this.fromCents(workspaceCents)
                    this.transactionForm.original_amount = this.formattedAccountAmount
                }
            }
        },

        calculateDirectExchange(inputTrigger) {
            if (['original_amount', 'direct_exchange_rate'].includes(inputTrigger)) {
                if (
                    this.transactionForm.original_amount != null &&
                    this.transactionForm.direct_exchange_rate != null
                ) {
                    const originalCents = this.toCents(this.formattedOriginalAmount)
                    const rate = Number(this.formattedDirectExchangeRate)
                    const accountCents = Math.round(originalCents * rate)

                    this.transactionForm.account_amount = this.fromCents(accountCents)
                }
            } else if (inputTrigger === 'account_amount') {
                if (
                    this.transactionForm.account_amount != null &&
                    this.transactionForm.direct_exchange_rate != null
                ) {
                    const accountCents = this.toCents(this.formattedAccountAmount)
                    const rate = Number(this.formattedDirectExchangeRate)
                    const originalCents = Math.round(accountCents / rate)

                    this.transactionForm.original_amount = this.fromCents(originalCents)
                }
            }

            if (
                this.transactionForm.original_amount != null &&
                this.transactionForm.account_amount != null &&
                (this.transactionForm.direct_exchange_rate == null ||
                    this.transactionForm.direct_exchange_rate === 0)
            ) {
                const originalCents = this.toCents(this.formattedOriginalAmount)
                const accountCents = this.toCents(this.formattedAccountAmount)

                if (originalCents !== 0) {
                    const computedRate = accountCents / originalCents

                    this.transactionForm.direct_exchange_rate = this.roundToEight(computedRate)
                }
            }

            if (
                this.transactionForm.direct_exchange_rate != null &&
                this.transactionForm.account_exchange_rate != null
            ) {
                const directRate = Number(this.formattedDirectExchangeRate)
                const accountRate = Number(this.formattedAccountExchangeRate)

                if (accountRate !== 0) {
                    this.transactionForm.original_exchange_rate = this.roundToEight(
                        directRate / accountRate
                    )
                }
            }

            if (
                this.transactionForm.original_amount != null &&
                this.transactionForm.original_exchange_rate != null
            ) {
                this.transactionForm.workspace_currency_amount = this.computeWorkspaceAmount(
                    this.formattedOriginalAmount,
                    this.formattedOriginalExchangeRate
                )
            }

            if (
                this.transactionForm.account_amount != null &&
                this.transactionForm.workspace_currency_amount != null
            ) {
                const accountCents = this.toCents(this.formattedAccountAmount)
                const workspaceCents = this.toCents(this.formattedWorkspaceAmount)

                if (workspaceCents !== 0) {
                    const accountExchangeRate = accountCents / workspaceCents

                    this.transactionForm.account_exchange_rate =
                        this.roundToEight(accountExchangeRate)
                }
            }
        },

        async setValues() {
            this.suppressAmountWatch = true
            this.suppressCurrencyWatch = true

            this.transactionForm.type = this.transaction.type
            this.transactionForm.main_financial_account_id =
                this.transaction.main_financial_account?.id
            this.transactionForm.main_financial_account_name =
                this.transaction.main_financial_account?.name
            this.transactionForm.main_financial_account_currency =
                this.transaction.main_financial_account?.currency
            this.transactionForm.additional_financial_account_id =
                this.transaction.additional_financial_account?.id
            this.transactionForm.additional_financial_account_name =
                this.transaction.additional_financial_account?.name
            this.transactionForm.additional_financial_account_currency =
                this.transaction.additional_financial_account?.currency
            this.transactionForm.original_currency = this.transaction.original_currency
            this.transactionForm.account_currency = this.transaction.account_currency
            this.transactionForm.is_direct_exchange = this.transaction.is_direct_exchange

            await this.$nextTick()

            this.suppressAmountWatch = false
            this.suppressCurrencyWatch = false

            this.updateFormFields(false, false).then(async () => {
                if (this.transaction.transaction_category) {
                    this.$refs.transactionCategorySelect.select(
                        this.transaction.transaction_category
                    )
                }

                this.transactionForm.date = this.transaction.date
                this.transactionForm.original_amount = this.transaction.original_amount
                this.transactionForm.original_exchange_rate =
                    this.transaction.original_exchange_rate
                this.transactionForm.workspace_currency_amount =
                    this.transaction.workspace_currency_amount
                this.transactionForm.direct_exchange_rate = this.transaction.direct_exchange_rate
                this.transactionForm.account_amount = this.transaction.account_amount
                this.transactionForm.account_exchange_rate = this.transaction.account_exchange_rate
                this.transactionForm.labels =
                    this.transaction.labels?.map((label) => label.id) || []
                this.transactionForm.documents = this.transaction.documents.map((document) => {
                    return {
                        id: document.uuid,
                        name: document.name,
                        savedFile: true
                    }
                })
                this.transactionForm.comment = this.transaction.comment
            })
        },

        onTransactionTypeChange() {
            this.$refs.transactionCategorySelect?.clear()
            this.$refs.transactionCategorySelect?.refreshOptions(() => {})
        },

        async searchCategory(query) {
            if (!this.transactionForm.type) {
                return []
            }

            let response

            try {
                response = await fetchWrapper.post(
                    `${import.meta.env.VITE_FINANCE_URL}/transactions/get-transaction-categories`,
                    {
                        type: this.transactionForm.type,
                        search: query
                    }
                )
            } catch (error) {
                const errorMessage =
                    error.response?.data?.message || error.message || 'Сталася помилка'

                this.$toast.error(errorMessage)
                console.error(error)
            }

            const options = response?.data || []

            if (!options.length) {
                return []
            }

            return options.map((item) => ({
                id: item.id,
                name: item.name,
                slug: item.slug
            }))
        },

        async searchLabel(query) {
            let response

            try {
                response = await fetchWrapper.post(
                    `${import.meta.env.VITE_FINANCE_URL}/transactions/get-labels`,
                    {
                        search: query,
                        page: 1
                    }
                )
            } catch (error) {
                const errorMessage =
                    error.response?.data?.message || error.message || 'Сталася помилка'

                this.$toast.error(errorMessage)
                console.error(error)
            }

            const options = response?.labels?.data || []

            if (!options.length) {
                return []
            }

            return options.map((item) => ({
                id: item.id,
                name: item.name,
                color: item.color
            }))
        },

        openAccountSelectModal(accountType) {
            this.accountTypeToSelect = accountType
            this.showAccountSelectModal = true
        },

        selectAccount(item) {
            if (this.accountTypeToSelect === 'main') {
                this.transactionForm.main_financial_account_id = item.id
                this.transactionForm.main_financial_account_name = item.name
                this.transactionForm.main_financial_account_currency = item.currency
                if ([3, 6, 7].includes(this.transactionCase)) {
                    this.updateFormFields()
                }
                this.$nextTick(() => {
                    this.$refs.originalCurrencySelect?.select(item.currency)
                })
            }

            if (this.accountTypeToSelect === 'addition') {
                this.transactionForm.additional_financial_account_id = item.id
                this.transactionForm.additional_financial_account_name = item.name
                this.transactionForm.additional_financial_account_currency = item.currency
                if ([6, 7].includes(this.transactionCase)) {
                    this.updateFormFields()
                }
                this.$nextTick(() => {
                    this.$refs.accountCurrencySelect?.select(item.currency)
                })
            }

            this.accountTypeToSelect = null
            this.showAccountSelectModal = false
        },

        cancelAccountSelect() {
            this.accountTypeToSelect = null
            this.showAccountSelectModal = false
        },

        loadImage(formData) {
            this.convertFilesToURLs(formData)
        },

        convertFilesToURLs(formData) {
            return new Promise((resolve, reject) => {
                const promises = []
                const documents = []

                const generateUniqueId = () => Math.random().toString(36).substring(2, 15)

                formData.getAll('documents[]').forEach((file) => {
                    const reader = new FileReader()

                    const promise = new Promise((resolveReader, rejectReader) => {
                        reader.onload = () => {
                            const uniqueId = generateUniqueId()

                            documents.push({
                                id: uniqueId,
                                name: file.name,
                                file: file
                            })
                            resolveReader()
                        }
                        reader.onerror = (error) => {
                            rejectReader(error)
                        }
                    })

                    reader.readAsDataURL(file)
                    promises.push(promise)
                })

                Promise.all(promises)
                    .then(() => {
                        this.transactionForm.documents.push(...documents)
                        resolve(this.transactionForm.documents)
                    })
                    .catch((error) => {
                        this.$toast.error(error)
                        reject(error)
                    })
            })
        },

        submitImageDelete(itemIndex, document) {
            if (document.savedFile) {
                this.transactionForm.delete_documents.push(document.id)
            }
            this.transactionForm.documents = this.transactionForm.documents.filter(
                (item) => item.id !== document.id
            )
        },

        submitForm() {
            if (!this.transactionForm.main_financial_account_id) {
                this.main_financial_account_error = 'Поле основний рахунок обовʼязкове.'
            } else {
                this.main_financial_account_error = null
            }

            this.sendRequest()
        },

        async sendRequest() {
            this.showLoader = true
            if (!this.activeRouteStore.routeId) {
                await this.activeRouteStore.getActiveRouteId()
            }

            const url =
                this.type === 'create'
                    ? 'create'
                    : this.type === 'edit'
                      ? `edit/${this.transactionId}`
                      : ''

            const properties = [
                { key: 'route_id', value: this.activeRouteStore.routeId },
                { key: 'route_name', value: this.activeRouteStore.routeName }
            ]

            fetchWrapper
                .post(
                    `${import.meta.env.VITE_FINANCE_URL}/transactions/${url}`,
                    {
                        ...this.transactionForm,
                        documents: this.transactionForm.documents.filter(
                            (item) => item.savedFile !== true
                        ),
                        properties
                    },
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                )
                .then(() => {
                    this.$toast.success('Транзакцію збережено')
                    this.$router.push({ name: 'transactionsPage' })
                })
                .finally(() => {
                    this.showLoader = false
                })
        },

        openConfirmTransactionDeleteModal() {
            this.confirmTransactionDeleteModal.show = true
            this.confirmTransactionDeleteModal.transaction_id = this.transaction.id
        },

        deleteTransaction() {
            this.showLoader = true
            fetchWrapper
                .delete(
                    `${import.meta.env.VITE_FINANCE_URL}/transactions/delete/${
                        this.confirmTransactionDeleteModal.transaction_id
                    }`
                )
                .then(() => {
                    this.$toast.success('Транзакцію успішно видалено')
                    this.closeForm()
                    this.cancelTransactionDelete()
                })
                .catch((error) => {
                    const errorMessage =
                        error.response?.data?.message || error.message || 'An error occurred'

                    this.$toast.error(errorMessage)
                })
                .finally(() => {
                    this.showLoader = false
                })
        },

        cancelTransactionDelete() {
            this.confirmTransactionDeleteModal.show = false
            this.confirmTransactionDeleteModal.transaction_id = null
        },

        closeForm() {
            if (window.history.length > 1) {
                this.$router.back()
            } else {
                this.$router.push({ name: 'homePage' })
            }
        }
    }
}
</script>

<style scoped lang="scss">
.transaction-form-page {
    position: relative;
    height: 100%;

    & > .container {
        height: 100%;
        padding-right: 0;
    }

    .page-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 1.25rem;
    }

    .page-title {
        &.create {
            width: 100%;
        }
    }

    .delete-btn {
        display: flex;
    }
}

.transaction-form {
    padding: 2rem 0 5rem;
    height: 100%;

    .form-inner {
        overflow: auto;
        height: 100%;
        padding-right: 1rem;
        padding-bottom: 2rem;
    }
}

.date-picker-wrap {
    margin-bottom: 1.25rem;
}

.account-select {
    position: relative;
    margin-top: 0.5rem;
    margin-bottom: 1.25rem;
    width: 100%;

    &:hover {
        cursor: pointer;

        .account-group .account-select-btn {
            background: rgba($grey, 0.4);
        }
    }

    .account-group {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        height: 3rem;
        border-radius: 0.5rem;
        outline: none;
        background: $grey-light;
        overflow: hidden;
        padding-left: 1rem;

        &.not-empty + .account-label {
            top: -0.5rem;
            padding: 0 0.25rem;
            font-size: 0.75rem;
            background: $white;
            border-radius: 0.25rem;
            transform: translateY(0);
        }

        .account-select-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
            width: 2.625rem;
            background: $white;
            border: 1px solid $grey-light;
            border-radius: 0.5rem;
            overflow: hidden;
            transition: all ease-in-out 0.3s;
        }
    }

    .account-label {
        display: flex;
        position: absolute;
        top: 1.6rem;
        left: 1rem;
        color: $grey;
        transform: translateY(-50%);
        transition: all ease-in-out 0.3s;
        pointer-events: none;
    }

    .account-error {
        padding: 0 1rem;

        span {
            color: $red;
            margin-right: 0.5rem;
        }
    }
}

.workspace-error {
    padding: 0 1rem;

    span {
        color: $red;
        margin-right: 0.5rem;
    }
}

.cross-curs-switch {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    cursor: pointer;
    margin-bottom: 1.25rem;
    img {
        margin-right: 0.25rem;
    }
}

.sum-block {
    margin-bottom: 1rem;

    .block-row {
        display: flex;
        align-items: center;

        .divider {
            height: 1px;
            flex-grow: 1;
            background: $grey-light;
        }

        .block-title {
            margin: 0 1rem;

            span {
                &:first-of-type {
                    margin-right: 0.625rem;
                }
            }
        }
    }
}

.images-component {
    border-bottom: none;
}

.page-buttons {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 1rem;
    z-index: 5;
    background: $white;

    .container {
        display: flex;
        justify-content: space-between;
        padding-right: 1rem !important;
    }

    .cancel-btn,
    .submit-btn {
        width: calc(50% - 0.5rem) !important;
    }
}

.loader-overlay {
    opacity: 0.7;
}
</style>
